"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ProfileSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/ProfileSettingsCard"));
var _RegionSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/RegionSettingsCard"));
var _ThemeSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/ThemeSettingsCard"));
var _PasswordSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/PasswordSettingsCard"));
var _TwoFactorAuthSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/TwoFactorAuthSettingsCard"));
var _EmailSettingsCard = _interopRequireDefault(require("../../components/Settings/ProfileAndSecurity/EmailSettingsCard/EmailSettingsCard.js"));
require("./ProfileAndSecurityLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var profileAndSettingsClasses = (0, _cssClassesHelper.getBEMClasses)(['profile-and-security-layout']);
var ProfileAndSecurityLayout = function ProfileAndSecurityLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('main')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('info')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('page-header')
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: profileAndSettingsClasses('title')
  }, t('Update Profile and Security Settings.')), /*#__PURE__*/_react["default"].createElement("h2", {
    className: profileAndSettingsClasses('sub-title')
  }, t(' Here you can make general settings such as...'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_ProfileSettingsCard["default"], null), /*#__PURE__*/_react["default"].createElement(_RegionSettingsCard["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('row', 'sm')
  }, /*#__PURE__*/_react["default"].createElement(_ThemeSettingsCard["default"], null), /*#__PURE__*/_react["default"].createElement(_EmailSettingsCard["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: profileAndSettingsClasses('row', 'sm')
  }, /*#__PURE__*/_react["default"].createElement(_TwoFactorAuthSettingsCard["default"], null), /*#__PURE__*/_react["default"].createElement(_PasswordSettingsCard["default"], null))));
};
var _default = exports["default"] = ProfileAndSecurityLayout;